import React, { useState, FC, PropsWithChildren, useEffect } from "react"

import { collection, FirestoreError, limit, onSnapshot, orderBy, query } from "firebase/firestore"

import { ObservationDocument, ObservationsContext } from "."
import { firebase } from "../../services/firebase/firebase"
import observationConverter from "./utils/observationConverter"
import { DeviceDocument } from "../devices-context"

type ObservationsProviderProps = {
    device: DeviceDocument
}

export const ObservationsProvider: FC<PropsWithChildren<ObservationsProviderProps>> = ({ children, device }) => {
    const [data, setData] = useState<ObservationDocument[]>([])
    const [latest, setLatest] = useState<ObservationDocument>()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<FirestoreError>()

    useEffect(
        () =>
            onSnapshot(
                query(
                    collection(
                        firebase.firestore,
                        `organisations/${device.organisation}/things/${device.id}/observations`,
                    ),
                    orderBy("timestamp", "desc"),
                    limit(1000),
                ).withConverter(observationConverter),
                snapshot => {
                    const docs = snapshot.docs.map(doc => doc.data())
                    setData(docs)
                    setLatest(docs.at(-1))
                    setLoading(false)
                },
                setError,
            ),
        [device],
    )

    return (
        <ObservationsContext.Provider value={{ data, latest, loading, error }}>{children}</ObservationsContext.Provider>
    )
}
